import { docAppStatusCheckboxOption, ediExportTypeCheckboxOption } from "presentation/constant/CheckBox/StaticCheckboxOptions";
import { CriteriaDirectoryDocumentCheckboxOption } from "presentation/constant/DocumentEnquiry/CriteriaDirectoryCheckboxOption";
import { DocumentEnquiryConstant } from "presentation/constant/DocumentEnquiry/DocumentEnquiryConstant";
import { useDocumentEnquiryVM } from "presentation/hook/DocumentEnquiry/useDocumentEnquiryVM";
import { useDocumentEnquiryTracked } from "presentation/store/DocumentEnquiry/DocumentEnquiryProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { FieldType, IFieldValue, NbisCommonField } from "presentation/view/components/NbisCommonField";
import NbisInputDropDown from "presentation/view/components/NbisInputDropDown";
import { useMemo } from "react";
import {
    GroupCheckboxList,
    HPHGroupCheckbox,
    HPHGroupTitle
} from "veronica-ui-component/dist/component/core";


export const DocumentEnquiryCriteriaEditDocumentPanel = () => {
    const DOC_ENQ_HDR_CONST = DocumentEnquiryConstant.Header;
    const [docEnquiryState] = useDocumentEnquiryTracked();
    const searchCriteria = docEnquiryState.searchCriteria;
    const docEnquiryVM = useDocumentEnquiryVM();
    const enabledCriteria = useMemo(() => CriteriaDirectoryDocumentCheckboxOption?.find(item => docEnquiryState.enabledSearchCriteria[item.key]), [docEnquiryState.enabledSearchCriteria]);

    const memoState = useMemo(() =>
        <>
            <div className='im-flex-row-item'>
                <HPHGroupCheckbox
                    label={DOC_ENQ_HDR_CONST.STATE}
                    checkboxData={[
                        { key: "NIL", name: "NIL", disabled: false },
                        { key: "INV", name: "INV", disabled: false }
                    ]}
                    selectedValues={searchCriteria.stateList}
                    orientation={"horizontal"}
                    onChange={(e: (GroupCheckboxList | undefined)[]) => docEnquiryVM.onGroupCheckboxChange(e, "stateList")}
                />
            </div>
        </>
        , [DOC_ENQ_HDR_CONST.STATE, searchCriteria, docEnquiryVM])

    const memoOriDocNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.oriDocNo || ''}
                fieldValue={searchCriteria.oriDocNo}
                fieldLabel={DOC_ENQ_HDR_CONST.ORI_DOC_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'oriDocNo'}
                maxLength={15}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.ORI_DOC_NO, searchCriteria.oriDocNo, docEnquiryVM])

    const memoDocType = useMemo(() =>
        <>
            <div className='im-flex-row-item'>
                <HPHGroupCheckbox
                    label={DOC_ENQ_HDR_CONST.DOC_TYPE}
                    checkboxData={[
                        { key: "IN", name: "IN", disabled: false },
                        { key: "CN", name: "CN", disabled: false }
                    ]}
                    selectedValues={searchCriteria.docTypeList}
                    orientation={"horizontal"}
                    onChange={(e: (GroupCheckboxList | undefined)[]) => docEnquiryVM.onGroupCheckboxChange(e, "docTypeList")}
                />
            </div>
        </>
        , [DOC_ENQ_HDR_CONST.DOC_TYPE, searchCriteria, docEnquiryVM])

    const memoInvNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.invNo || ''}
                fieldValue={searchCriteria.invNo}
                fieldLabel={DOC_ENQ_HDR_CONST.INV_CRE_NOTE_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'invNo'}
                maxLength={15}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria.invNo, docEnquiryVM, DOC_ENQ_HDR_CONST.INV_CRE_NOTE_NO])
    const memoDraftDocNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.draftDocNo || ''}
                fieldValue={searchCriteria.draftDocNo}
                fieldLabel={DOC_ENQ_HDR_CONST.DRAFT_INVOICE_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'draftDocNo'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria.draftDocNo, docEnquiryVM, DOC_ENQ_HDR_CONST.DRAFT_INVOICE_NO])
    const memoInvDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={DOC_ENQ_HDR_CONST.INVOICE_DATE_RANGE}
                width="330px"
                fieldNames={{ startField: "invDateFrom", endField: "invDateTo" }}
                dateRange={{ startDate: searchCriteria.invDateFrom, endDate: searchCriteria.invDateTo }}
                onDatesChange={docEnquiryVM.onDateRangeChange}
            />
        </div>
        , [searchCriteria.invDateFrom, searchCriteria.invDateTo, docEnquiryVM, DOC_ENQ_HDR_CONST.INVOICE_DATE_RANGE])

    const memoGenDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={DOC_ENQ_HDR_CONST.GEN_DATE_RANGE}
                width="330px"
                fieldNames={{ startField: "genDateFrom", endField: "genDateTo" }}
                dateRange={{ startDate: searchCriteria.genDateFrom, endDate: searchCriteria.genDateTo }}
                onDatesChange={docEnquiryVM.onDateRangeChange}
            />
        </div>
        , [DOC_ENQ_HDR_CONST.GEN_DATE_RANGE, searchCriteria.genDateFrom, searchCriteria.genDateTo, docEnquiryVM.onDateRangeChange])

    const memoGenBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.generatedBy || ''}
                fieldValue={searchCriteria.generatedBy}
                fieldLabel={DOC_ENQ_HDR_CONST.GEN_BY}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'generatedBy'}
                maxLength={30}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.GEN_BY, searchCriteria.generatedBy, docEnquiryVM])

    const memoIssueBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.issuedBy || ''}
                fieldValue={searchCriteria.issuedBy}
                fieldLabel={DOC_ENQ_HDR_CONST.ISSUED_BY}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'issuedBy'}
                maxLength={30}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.ISSUED_BY, searchCriteria.issuedBy, docEnquiryVM])

    const memoPubWeb = useMemo(() =>
        <>
            <div className='im-flex-row-item'>
                <HPHGroupCheckbox
                    label={DOC_ENQ_HDR_CONST.PUB_WEB_SITE}
                    checkboxData={[
                        { key: "Y", name: "Y", disabled: false },
                        { key: "N", name: "N", disabled: false }
                    ]}
                    selectedValues={searchCriteria.publicAtWebSiteList}
                    orientation={"horizontal"}
                    onChange={(e: (GroupCheckboxList | undefined)[]) => docEnquiryVM.onGroupCheckboxChange(e, "publicAtWebSiteList")}
                />
            </div>
        </>
        , [DOC_ENQ_HDR_CONST.PUB_WEB_SITE, searchCriteria, docEnquiryVM])



    const memoIssuedEdi = useMemo(() =>
        <>
            <div className='im-flex-row-item'>
                <HPHGroupCheckbox
                    label={DOC_ENQ_HDR_CONST.EXP_TYPE}
                    checkboxData={ediExportTypeCheckboxOption}
                    selectedValues={searchCriteria.issueByEdiList}
                    orientation={"horizontal"}
                    onChange={(e: (GroupCheckboxList | undefined)[]) => docEnquiryVM.onGroupCheckboxChange(e, "issueByEdiList")}
                />
            </div>
        </>
        , [DOC_ENQ_HDR_CONST.EXP_TYPE, searchCriteria, docEnquiryVM])



    const memoAppStatus = useMemo(() =>
        <>
            <div className='im-flex-row-item'>
                <HPHGroupCheckbox
                    label={DOC_ENQ_HDR_CONST.APPR_STATUS}
                    checkboxData={docAppStatusCheckboxOption}
                    selectedValues={searchCriteria.approvalStatusList}
                    orientation={"horizontal"}
                    onChange={(e: (GroupCheckboxList | undefined)[]) => docEnquiryVM.onGroupCheckboxChange(e, "approvalStatusList")}
                />
            </div>
        </>
        , [DOC_ENQ_HDR_CONST.APPR_STATUS, searchCriteria, docEnquiryVM])


    const memoApprDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={DOC_ENQ_HDR_CONST.APPR_DATE_RANGE}
                width="330px"
                fieldNames={{ startField: "approvalDatetimeFrom", endField: "approvalDatetimeTo" }}
                dateRange={{ startDate: searchCriteria.approvalDatetimeFrom, endDate: searchCriteria.approvalDatetimeTo }}
                onDatesChange={docEnquiryVM.onDateRangeChange}
            />
        </div>
        , [DOC_ENQ_HDR_CONST.APPR_DATE_RANGE, searchCriteria.approvalDatetimeFrom, searchCriteria.approvalDatetimeTo, docEnquiryVM.onDateRangeChange])

    const memoTransactionType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.transactionType || ''}
                fieldValue={searchCriteria.transactionType}
                fieldLabel={DOC_ENQ_HDR_CONST.TRANSACTION_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'transactionType'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.TRANSACTION_TYPE, searchCriteria.transactionType, docEnquiryVM])

    const memoTaxCode = useMemo(() =>
        <div className='im-flex-row-item'>
            <NbisInputDropDown
                label={DOC_ENQ_HDR_CONST.TAX_CODE}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.taxCodeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => docEnquiryVM.onMultipleDropdownChange(e, 'taxCodeList')}
                options={docEnquiryState.dynamicOptions.taxCodeDropdownOptions} />
        </div>
        , [DOC_ENQ_HDR_CONST.TAX_CODE, searchCriteria.taxCodeList, docEnquiryState.dynamicOptions.taxCodeDropdownOptions, docEnquiryVM])

    const memoTaxDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={DOC_ENQ_HDR_CONST.TAX_DATE_RANGE}
                width="330px"
                fieldNames={{ startField: "taxDateFrom", endField: "taxDateTo" }}
                dateRange={{ startDate: searchCriteria.taxDateFrom, endDate: searchCriteria.taxDateTo }}
                onDatesChange={docEnquiryVM.onDateRangeChange}
            />
        </div>
        , [DOC_ENQ_HDR_CONST.TAX_DATE_RANGE, searchCriteria.taxDateFrom, searchCriteria.taxDateTo, docEnquiryVM.onDateRangeChange])

    const memoTaxPaymentTerm = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.taxPaymentTerm || ''}
                fieldValue={searchCriteria.taxPaymentTerm}
                fieldLabel={DOC_ENQ_HDR_CONST.TAX_PAYMENT_TERM}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'taxPaymentTerm'}
                maxLength={999}
                decimalPlaces={0}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.TAX_PAYMENT_TERM, searchCriteria.taxPaymentTerm, docEnquiryVM])

    const memoPanel = useMemo(() => <>
        {enabledCriteria ? <div className='im-charge-data-search-criteria-group'>
            <HPHGroupTitle titleText={DOC_ENQ_HDR_CONST.DOCUMENT} />
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.invNo ? memoInvNo : null}
                {docEnquiryState.enabledSearchCriteria.oriDocNo ? memoOriDocNo : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.draftDocNo ? memoDraftDocNo : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.stateList ? memoState : null}
                {docEnquiryState.enabledSearchCriteria.docTypeList ? memoDocType : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.invDate ? memoInvDateFromTo : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.genDate ? memoGenDateFromTo : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.generatedBy ? memoGenBy : null}
                {docEnquiryState.enabledSearchCriteria.issuedBy ? memoIssueBy : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.issueByEdiList ? memoIssuedEdi : null}
                {docEnquiryState.enabledSearchCriteria.publicAtWebSiteList ? memoPubWeb : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.transactionType ? memoTransactionType : null}
                {docEnquiryState.enabledSearchCriteria.taxCodeList ? memoTaxCode : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.taxDate ? memoTaxDateFromTo : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.taxPaymentTerm ? memoTaxPaymentTerm : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.approvalStatusList ? memoAppStatus : null}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {docEnquiryState.enabledSearchCriteria.approvalDatetime ? memoApprDateFromTo : null}
            </CriteriaItemContainer>
        </div> : null}</>
        , [DOC_ENQ_HDR_CONST.DOCUMENT, docEnquiryState.enabledSearchCriteria.approvalDatetime, docEnquiryState.enabledSearchCriteria.approvalStatusList,
        docEnquiryState.enabledSearchCriteria.docTypeList, docEnquiryState.enabledSearchCriteria.genDate, docEnquiryState.enabledSearchCriteria.generatedBy,
        docEnquiryState.enabledSearchCriteria.invDate, docEnquiryState.enabledSearchCriteria.invNo, docEnquiryState.enabledSearchCriteria.issueByEdiList,
        docEnquiryState.enabledSearchCriteria.issuedBy, docEnquiryState.enabledSearchCriteria.oriDocNo, docEnquiryState.enabledSearchCriteria.draftDocNo,
        docEnquiryState.enabledSearchCriteria.publicAtWebSiteList, docEnquiryState.enabledSearchCriteria.stateList, docEnquiryState.enabledSearchCriteria.taxCodeList,
        docEnquiryState.enabledSearchCriteria.taxDate, docEnquiryState.enabledSearchCriteria.taxPaymentTerm, docEnquiryState.enabledSearchCriteria.transactionType,
            enabledCriteria, memoAppStatus, memoApprDateFromTo, memoDocType, memoGenBy, memoGenDateFromTo, memoInvDateFromTo, memoInvNo, memoIssueBy, memoIssuedEdi, memoOriDocNo,
            memoDraftDocNo, memoPubWeb, memoState, memoTaxCode, memoTaxDateFromTo, memoTaxPaymentTerm, memoTransactionType]);

    return memoPanel;
};
